import { useMemo } from 'react';
import { useProductPricingApi } from 'app/common/hooks';
import { get, isEmpty } from 'lodash';
import { determineProductOrVariantPricing } from 'app/product/utils/PricingUtils';

function usePriceProducts(products) {
  const priceInfoResponse = useProductPricingApi(products);

  return useMemo(() => {
    const prices = new Map();

    if (!isEmpty(priceInfoResponse)) {
      for (let product of products) {
        const priceInfoContainer = get(priceInfoResponse, product.id);
        if (priceInfoContainer) {
          const priceInfo = priceInfoContainer.priceInfo;
          const productPricing = determineProductOrVariantPricing(
            product,
            priceInfo
          );
          prices.set(product.id, productPricing || {});
        }
      }
    }

    return prices;
  }, [products, priceInfoResponse]);
}

export default usePriceProducts;
